import React from 'react';
import { useUserSegment } from '../../context/UserSegmentContext';
import './UserSegmentToggle.css';

/**
 * Global "Watch users / All users" segment toggle (feature 023).
 *
 * A single control backed by UserSegmentContext, so every page that renders it
 * shares (and updates) the same session-global segment. Defaults to "Watch users".
 *
 * @param {Object}  props
 * @param {string}  [props.label='Showing']  small leading label
 * @param {string}  [props.className='']      extra class on the wrapper
 */
const UserSegmentToggle = ({ label = 'Showing', className = '' }) => {
  const { segment, setSegment } = useUserSegment();
  return (
    <div
      className={`seg-toggle ${className}`.trim()}
      role="group"
      aria-label="User segment"
      data-testid="user-segment-toggle"
    >
      {label ? <span className="seg-toggle__label">{label}</span> : null}
      <button
        type="button"
        data-testid="segment-watch"
        className={segment === 'watch' ? 'seg-toggle__btn is-active' : 'seg-toggle__btn'}
        aria-pressed={segment === 'watch'}
        onClick={() => setSegment('watch')}
      >
        Watch users
      </button>
      <button
        type="button"
        data-testid="segment-without"
        className={segment === 'without_watch' ? 'seg-toggle__btn is-active' : 'seg-toggle__btn'}
        aria-pressed={segment === 'without_watch'}
        onClick={() => setSegment('without_watch')}
      >
        Without watch
      </button>
      <button
        type="button"
        data-testid="segment-all"
        className={segment === 'all' ? 'seg-toggle__btn is-active' : 'seg-toggle__btn'}
        aria-pressed={segment === 'all'}
        onClick={() => setSegment('all')}
      >
        All users
      </button>
    </div>
  );
};

export default UserSegmentToggle;
